import { DisclosureButton } from '@headlessui/react';
import { Menu, X } from 'lucide-react';
import React from 'react';

interface Props {
  open: boolean;
}

const MenuButton: React.FC<Props> = ({ open }: Props) => {
  return (
    <div className="-mr-2 flex md:hidden">
      {/* Mobile menu button */}
      <DisclosureButton className="bg-white inline-flex items-center justify-center p-2 rounded-md text-default hover:text-default hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
        <span className="sr-only">Open main menu</span>
        {open ? (
          <X className="block h-6 w-6" aria-hidden="true" />
        ) : (
          <Menu className="block h-6 w-6" aria-hidden="true" />
        )}
      </DisclosureButton>
    </div>
  );
};

export default MenuButton;
